import { render } from "./RecebimentoMercadoriasRevisarInformacoes.vue?vue&type=template&id=50179118&scoped=true&ts=true"
import script from "./RecebimentoMercadoriasRevisarInformacoes.vue?vue&type=script&lang=ts"
export * from "./RecebimentoMercadoriasRevisarInformacoes.vue?vue&type=script&lang=ts"

import "./RecebimentoMercadoriasRevisarInformacoes.vue?vue&type=style&index=0&id=50179118&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50179118"]])

export default __exports__